import * as net from '~/lib/net';

import { AccountsEndpoints } from './endpoints';
import { getToken } from '~/apps/shared/services/token';


export async function getKYC() {
  const data = await net.apiGet(AccountsEndpoints.kyc(), getToken());
  return { data };
}

export async function setKYC(kycData: any) {
  const data = await net.apiPost(AccountsEndpoints.kyc(), getToken(), kycData);
  return { data };
}
